import { ExportOutlined } from "@ant-design/icons"
import { Dropdown } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface SidebarContextMenuProps {
  open: boolean
  x: number
  y: number
  onOpenChange: (open: boolean) => void
  onOpenInNewTab: () => void
}

export const SidebarContextMenu = ({
  open,
  x,
  y,
  onOpenChange,
  onOpenInNewTab
}: SidebarContextMenuProps) => {
  const { t } = useTranslation()

  return (
    <Dropdown
      open={open}
      onOpenChange={onOpenChange}
      trigger={["contextMenu"]}
      menu={{
        items: [
          {
            key: "open-in-new-tab",
            icon: <ExportOutlined />,
            label: t("sidebar.openInNewTab")
          }
        ],
        onClick: onOpenInNewTab
      }}
    >
      <span
        aria-hidden
        style={{
          position: "fixed",
          left: x,
          top: y,
          width: 1,
          height: 1,
          pointerEvents: "none"
        }}
      />
    </Dropdown>
  )
}
